import {IReduxUserState} from '../../@interfaces';
import Auth from '../../services/Auth/Auth';

const state: IReduxUserState = {
	accessToken: new Auth().getAccessToken() ?? undefined,
    preferences: {},
};

export default state;
